import { Texture, TextureLoader } from 'three';

export const load_texture = (url: string): Promise<Texture | Error> => new Promise(next => {
    const loader = new TextureLoader();
    loader.setCrossOrigin('');
    loader.load(
        url,
        next,
        undefined,
        (cause) => next(new Error('Error while loading texture', { cause })),
    );
});
